module.exports = __webpack_public_path__ + "static/media/logo.c73bc178.png";